import i18n from "@/i18n";
import Vue from "vue";
import config from "@/config";
import { STATUS_CODES } from "http";

export default {
  namespaced: true,
  state: {
    tour1: false,
    network: "unknown",
    menuX: false,
    menuY: 0,
    menu0: "all",
    menu1: "today",
    menu2: 1,
    menu3: "hdpou",
    menu4: "single",
    selectedDays: "1",
    upcomingHours: "1",
    minimizer: {
      header: true,
      sidebar: true,
      asidebar: true
    },
    pageDisplay: {
      language: config.defaultLang,
      oddsType: config.defaultOdds,
      pageType: "2",
      showScoreMap: "false",
      showQuickOdds: "false",
      eventSorting: "1",
      marketType: "1",
      pageSize: "10"
    },
    betting: {
      defaultStake: "0",
      acceptBetterOdds: "true",
      acceptAnyOdds: "false",
      autoRefreshOdds: "true",
      quickBet: "true",
      defaultStakeAmount: "1"
    },
    sports: {},
    league: {},
    leagueType: 2,
    test: 2,
    leagueFiltered: false,
    order: {
      sports: [],
      default: {
        sports: []
      }
    },
    options: {
      live: {},
      parlay: {}
    },
    search: "",
    selectLeague: [],
    selectedMatch: null,
    selectedMatchMore: {},
    favorite: [],
    menuList: {},
    mybet: 0,
    radarId: null,
    channel: null,
    theme: "color2",
    showTM: false
  },
  mutations: {
    updateTour1(state, payload) {
      state.tour1 = payload;
    },
    updateTheme(state, payload) {
      state.theme = payload;
    },
    updateNetwork(state, payload) {
      state.network = payload;
    },
    updateRadarId(state, payload) {
      state.radarId = payload;
    },
    updateChannelId(state, payload) {
      state.channel = payload;
    },
    updateMyBet(state, payload) {
      state.mybet = payload;
    },
    updateMenuList(state, payload) {
      state.menuList = payload;
    },
    updateShowTimeMachine(state, payload) {
      state.showTM = payload;
    },
    resetState(state, payload) {
      state.menuX = false;
      state.menuY = "0";
      state.menu0 = "all";
      state.menu1 = "today";
      state.menu2 = 1;
      state.menu3 = "hdpou";
      state.menu4 = "single";
      state.selectedDays = "1";
      state.selectedMatch = null;
      state.selectLeague = [];
      state.league = {};
      state.leagueFiltered = false;
      state.order.sports = [];
      state.order.default.sports = [];
    },
    clearSelectLeague(state, payload) {
      state.selectLeague = [];
      state.leagueFiltered = false;
    },
    updateSelectLeague(state, payload) {
      state.selectLeague = payload;
      state.leagueFiltered = true;
    },
    updateSelectedMatch(state, payload) {
      state.selectedMatch = payload;
    },
    updateSelectedMatchMore(state, payload) {
      state.selectedMatchMore = payload;
    },
    updateSearch(state, payload) {
      var old = state.search;
      state.search = payload;
      old = null;
    },
    updateOptions(state, payload) {
      state.options[payload.property] = payload.value;
    },
    updateSports(state, payload) {
      var defOrder = [];

      var cfgOrder = config.defaultSportOrder;
      if (payload["currency_code"] == "BDT") {
        cfgOrder = config.defaultSportOrder1;
      }
      for (var n in cfgOrder) {
        if (payload.items[cfgOrder[n]]) {
          defOrder.push(cfgOrder[n]);
        }
      }

      var tempOrder = [];
      for (var m in payload.items) {
        if (!cfgOrder.includes(parseInt(m))) {
          tempOrder.push({ key: m, value: payload.items[m] });
        }
      }
      tempOrder = Object.values(tempOrder).sort(function (a, b) {
        return a.value.toLowerCase() < b.value.toLowerCase() ? -1 : a.value.toLowerCase() > b.value.toLowerCase() ? 1 : 0;
      });

      for (var o in tempOrder) {
        defOrder.push(parseInt(tempOrder[o]["key"]));
      }

      state.order.default.sports = defOrder;
      if (state.order.sports.length <= 0) {
        state.order.sports = state.order.default.sports;
      }

      if (state.order.sports.length != defOrder.length) {
        state.order.sports = defOrder;
      }

      state.sports = payload.items;
    },
    updateLeague(state, payload) {
      state.league = payload;
    },
    updateLeagueType(state, payload) {
      state.leagueType = payload;
    },
    updateOrder(state, payload) {
      state.order[payload.property] = payload.value;
    },
    updateLanguage(state, payload) {
      i18n.locale = payload;
      state.pageDisplay.language = payload;
    },
    updateSinglePageDisplay(state, payload) {
      state.pageDisplay[payload.property] = payload.value;
    },
    updatePageDisplay(state, payload) {
      i18n.locale = payload.language;
      state.pageDisplay.language = payload.language;
      state.pageDisplay.oddsType = payload.oddsType;
      state.pageDisplay.pageType = payload.pageType;
      state.pageDisplay.marketType = payload.marketType;
      state.pageDisplay.showScoreMap = payload.showScoreMap;
      state.pageDisplay.showQuickOdds = payload.showQuickOdds;
      state.pageDisplay.eventSorting = payload.eventSorting;
      state.pageDisplay.pageSize = payload.pageSize;
    },
    updateOddsType(state, payload) {
      state.pageDisplay.oddsType = payload;
    },
    updateSingleBetting(state, payload) {
      state.betting[payload.property] = payload.value;
    },
    updateBetting(state, payload) {
      state.betting.defaultStake = payload.defaultStake;
      state.betting.acceptBetterOdds = payload.acceptBetterOdds;
      state.betting.acceptAnyOdds = payload.acceptAnyOdds;
      state.betting.autoRefreshOdds = payload.autoRefreshOdds;
      state.betting.quickBet = payload.quickBet;
      state.betting.defaultStakeAmount = payload.defaultStakeAmount;
    },
    updateMenu(state, payload) {
      Vue.set(state, payload.property, payload.value);
    },
    updateMenuItems(state, payload) {
      for (var k in payload) {
        Vue.set(state, k, payload[k]);
      }
    },
    updateMinimizer(state, payload) {
      state.minimizer[payload.property] = payload.value;
    },
    updateSelectedDays(state, payload) {
      state.selectedDays = payload;
    },
    updateUpcomingHours(state, payload) {
      state.upcomingHours = payload;
    },
    updateFavorite(state, payload) {
      if (payload) {
        payload.forEach(x => {
          if (state.favorite) {
            if (state.favorite.indexOf(x) == -1) {
              state.favorite.push(x);
            }
          }
        });
      }
    },
    removeFavorite(state, payload) {
      if (payload) {
        payload.forEach(x => {
          if (state.favorite) {
            var i = state.favorite.indexOf(x);
            if (i != -1) {
              state.favorite.splice(i, 1);
            }
          }
        });
      }
    },
    replaceFavorite(state, payload) {
      Vue.set(state, "favorite", payload);
    }
  },
  actions: {
    setTour1(context, payload) {
      context.commit("updateTour1", payload);
    },
    setTheme(context, payload) {
      context.commit("updateTheme", payload);
    },
    setNetwork(context, payload) {
      context.commit("updateNetwork", payload);
    },
    setRadarId(context, payload) {
      context.commit("updateRadarId", payload);
    },
    setChannelId(context, payload) {
      context.commit("updateChannelId", payload);
    },
    setMyBet(context, payload) {
      context.commit("updateMyBet", payload);
    },
    setMenuList(context, payload) {
      context.commit("updateMenuList", payload);
    },
    reset(context, payload) {
      context.commit("resetState", payload);
    },
    resetSelectLeague(context, payload) {
      context.commit("clearSelectLeague", payload);
    },
    setSelectLeague(context, payload) {
      context.commit("updateSelectLeague", payload);
    },
    setSelectedMatch(context, payload) {
      context.commit("updateSelectedMatch", payload);
    },
    setSelectedMatchMore(context, payload) {
      context.commit("updateSelectedMatchMore", payload);
    },
    setSearch(context, payload) {
      context.commit("updateSearch", payload);
    },
    setOptions(context, payload) {
      context.commit("updateOptions", payload);
    },
    setSports(context, payload) {
      context.commit("updateSports", payload);
    },
    setLeague(context, payload) {
      context.commit("updateLeague", payload);
    },
    setLeagueType(context, payload) {
      context.commit("updateLeagueType", payload);
    },
    setOrder(context, payload) {
      context.commit("updateOrder", payload);
    },
    setLanguage(context, payload) {
      context.commit("updateLanguage", payload);
    },
    setSinglePageDisplay(context, payload) {
      context.commit("updateSinglePageDisplay", payload);
    },
    setPageDisplay(context, payload) {
      context.commit("updatePageDisplay", payload);
    },
    setOddsType(context, payload) {
      context.commit("updateOddsType", payload);
    },
    setSingleBetting(context, payload) {
      context.commit("updateSingleBetting", payload);
    },
    setBetting(context, payload) {
      context.commit("updateBetting", payload);
    },
    setMenu(context, payload) {
      context.commit("updateMenu", payload);
    },
    setMenuItems(context, payload) {
      context.commit("updateMenuItems", payload);
    },
    setMinimizer(context, payload) {
      context.commit("updateMinimizer", payload);
    },
    setSelectedDays(context, payload) {
      context.commit("updateSelectedDays", payload);
    },
    setUpcomingHours(context, payload) {
      context.commit("updateUpcomingHours", payload);
    },
    setFavorite(context, payload) {
      context.commit("updateFavorite", payload);
    },
    delFavorite(context, payload) {
      context.commit("removeFavorite", payload);
    },
    copyFavorite(context, payload) {
      context.commit("replaceFavorite", payload);
    },
    setShowTimeMachine(context, payload) {
      context.commit("updateShowTimeMachine", payload);
    }

  }
};
